import { AvailabilityEnum } from '../../ProductTypes';
import { isPreOrder, preOrderAvailabilities } from '../../utils/availability.utils';

export const getProductAvailabilitiesToCleanOrder = (
  availability?: AvailabilityEnum | null,
): AvailabilityEnum[] => {
  if (!availability) {
    return [];
  }
  if (isPreOrder(availability)) {
    return preOrderAvailabilities;
  }
  return [availability as AvailabilityEnum];
};
